import { StatusConfig, StatusState } from '@gripp/shared-logic';
import { FC } from 'react';
import { RoutineButton } from '../components/routineButton';
import { RoutineButtonProps } from '../types';
import { StatusComponentProps } from './types';

interface StatusButtonsProps
  extends StatusComponentProps,
    RoutineButtonProps<StatusConfig, StatusState> {}

export const StatusButtons: FC<StatusButtonsProps> = (
  props: StatusButtonsProps
) => {
  return (
    <RoutineButton
      text={props.config.routineButtonText || ''}
      onClick={props.onClick}
      buttonStyle={props.styleOverrides?.buttonStyle}
      labelStyle={props.styleOverrides?.labelStyle}
      buttonIcon={props.styleOverrides?.buttonIcon}
      buttonIconStyle={props.styleOverrides?.buttonIconStyle}
      secondaryButtonIcon={props.styleOverrides?.secondaryButtonIcon}
      leftButtonIcon={props.styleOverrides?.leftButtonIcon}
      sync={props.styleOverrides?.sync}
    />
  );
};
